import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgModel } from '@angular/forms';

@Component({
  selector: 'app-internalnotes-modal',
  templateUrl: './internalnotes-modal.component.html',
})
export class InternalNotesModalComponent {
  @Input() readOnly: boolean;
  @Input() internalnotes: string;

  submitted = false;

  constructor(private activeModal: NgbActiveModal) {}

  submit() {
    this.submitted = true;
    if (this.internalnotes) {
      this.submitted = false;
      this.activeModal.close(this.internalnotes);
    }
  }

  ShowValidationMessage(item: NgModel): boolean {
    return item.errors && (this.submitted || !item.pristine || item.touched);
  }

  close(): void {
    this.activeModal.close(null);
  }
}
